import { ChartWidgetMetadata } from '@/modules/ta/widget/models/metadata/ChartWidgetMetadata';
import { SankeyChartDrawOption } from '@/modules/ta/widget/models/drawoptions/SankeyChartDrawOption';

export class SankeyChartWidgetMetadata extends ChartWidgetMetadata {
  constructor(model = {}) {
    super(model);

    this.draw_options = new SankeyChartDrawOption(model.draw_options);
  }
}
